import { apiRequest } from '@/lib/queryClient';
import { z } from 'zod';
import { languageCodes } from './interpreterPage.constants';

export const rowSchema = z.object({
  id: z.string().uuid(),
  turn_id: z.string().uuid(),
  n: z.number().int(),
  text: z.string(),
  translation: z.string().nullable(),
  speaker: z.enum(['doctor', 'patient']),
  language: z.enum(languageCodes),
  translation_status: z.enum(['pending', 'ready', 'failed']),
});
export const recordSchema = z.object({
  id: z.string().uuid(),
  source_audio_saved: z.boolean(),
  config: z.object({
    clinician_language: z.enum(['is', 'en']).default('is'),
    patient_language: z.enum(languageCodes).default('no'),
    phase: z.enum(['speaking', 'finishing', 'playback', 'paused', 'ended']),
    turn_id: z.string().uuid().nullable(),
    speaker: z.enum(['doctor', 'patient']),
  }),
  utterances: z.array(rowSchema),
});
export const ackSchema = z.object({
  ok: z.boolean(),
  code: z.string().nullable().optional(),
  record: recordSchema.optional(),
});
export type InterpreterRecord = z.infer<typeof recordSchema>;
export type InterpreterRow = z.infer<typeof rowSchema>;
export const recordRequest = async (method: string, path: string, body?: unknown): Promise<InterpreterRecord> =>
  recordSchema.parse(await (await apiRequest(method, `/api/interpreter${path}`, body)).json());

export const prepareSpeech = async (id: string, turn: string, n: number): Promise<string> => {
  const response = await apiRequest('POST', `/api/interpreter/${id}/speech/${turn}/${n}`, {});
  return z.object({ clip_id: z.string().uuid() }).parse(await response.json()).clip_id;
};
